import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { ISignatureSettings } from 'types/SignatureSettings';
import useMemberFeatureSettingsUpdate from '../member/useMemberFeatureSettingsUpdate';
import useMemberSettings from '../member/useMemberSettings';

export default function useSignatureSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateFeatureSettings = useMemberFeatureSettingsUpdate();

  return useCallback(
    <K extends keyof ISignatureSettings>(keysAndPayloads: { key: K; payload: ISignatureSettings[K] }[]) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.signatures);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        cloned
      );

      return updateFeatureSettings('signatures', mapped);
    },
    [memberSettings, updateFeatureSettings]
  );
}
